import styled from 'styled-components';

import {
  Flex,
  icons,
} from 'web-styled';

export const WorkoutWrapper = styled(Flex).attrs({
  column: true,
  padding: '15px',
  spacing: 15,
})`
  width: 100%;
  height: 100%;
  @media print {
    padding: 0;
    margin-top: 30px;
    display: block;

    & > span {
      margin: 0 !important;
    }
  }
`;

export const Empty = styled(Flex).attrs({
  justify: 'center',
})`
  opacity: 0.6;
  text-align: center;
  padding-top: 50px;
  padding-bottom: 30px;
  background: url(${icons.workoutsSingle}) top center no-repeat;

  @media print {
    display: none;
  }
`;

export const PrintPage = styled.div`
  display: block;
  @media print {
    break-after: page;
    page-break-inside: avoid;
  }
`;
